import React from "react";
import { Box, Typography, Slider, useTheme, useMediaQuery } from "@mui/material";
import { FlexContainer } from "../styled/Container.styled";

const FormItemSlider = ({
  label = "",
  value = 0,
  setValue = () => {},
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  errorMessage = "",
  marks = [],
  valueLabelDisplay = "off",
  startLabel = "",
  endLabel = "",
  topStartLabel = "",
  topEndLabel = "",
  ...sliderProps
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <FlexContainer flexdirection="column" gap="8px" width="100%">
      {label && (
        <Typography fontWeight="bold" fontSize={isMobile ? "1rem" : "1.1rem"}>
          {label}
        </Typography>
      )}
      <FlexContainer justifycontent="space-between" alignitems="center" width="100%">
        <Typography variant="body2" color="text.secondary" fontWeight={400} sx={{ fontSize: "0.875rem" }}>
          {topStartLabel}
        </Typography>
        <FlexContainer gap="4px" alignitems="center">
          <Typography variant="body2" color="text.secondary" fontWeight={400} sx={{ fontSize: "0.875rem" }}>
            {topEndLabel}
          </Typography>
          {topEndLabel && (
            <Box
              sx={{
                width: "14px",
                height: "14px",
                borderRadius: "50%",
                background: "rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                color: "text.secondary"
              }}
            >
              ?
            </Box>
          )}
        </FlexContainer>
      </FlexContainer>
      <Slider
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e, v) => setValue(v)}
        disabled={disabled}
        marks={marks}
        valueLabelDisplay={valueLabelDisplay}
        sx={{
          '& .MuiSlider-track': {
            background: theme.palette.primary.main,
            height: 3,
            borderRadius: 1.5
          },
          '& .MuiSlider-thumb': {
            width: 16,
            height: 16,
            background: '#fff',
            border: `2px solid ${theme.palette.primary.main}`,
            boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
          },
          '& .MuiSlider-rail': {
            height: 3,
            borderRadius: 1.5,
            background: '#f0f0f0'
          }
        }}
        {...sliderProps}
      />
      <FlexContainer justifycontent="space-between" alignitems="center" width="100%">
        <Typography variant="caption" color="text.primary" sx={{ fontSize: "0.7rem", fontWeight: 600 }}>
          {startLabel}
        </Typography>
        <Typography variant="caption" color="text.primary" sx={{ fontSize: "0.7rem", fontWeight: 600 }}>
          {endLabel}
        </Typography>
      </FlexContainer>
      {errorMessage && (
        <Typography color="error" fontSize="0.85rem">{errorMessage}</Typography>
      )}
    </FlexContainer>
  );
};

export default FormItemSlider; 